import axios from "axios";
import config from "../config/config";
var apiUrl = config.baseUrl;

export const savePurchase = async (data) => {

    try {
        let response = await axios({
            'method': 'post',
            'url': `${apiUrl}/buy-token`,
            'data': data
        });
        console.log(response, 'responseee')
        return {
            status: response?.data?.status || false,
            message: response?.data?.message || "",
            data: response?.data?.data || {},
        }
    }
    catch (err) {
        console.log(err, 'errerrerrerr')
        return {
            status: false,
            errors: {},
            message: "Failed to register",
        }
    }
}

export const getTxHistory = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/transaction-history?limit=${data.limit}&skip=${data.skip}`
        });
        console.log(response,"responseresponse");
        return {
            status: response?.data?.status || false,
            message: response?.data?.message || "",
            result: response?.data?.result || {},
            totalRecords: response?.data?.totalrecords || 0,
        }
    }
    catch (err) {
        return {
            status: false,
            errors: {},
            message: "Failed to register",
        }
    }
}


export const getTerms = async (identifier) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/fetch-cms?identifier=${identifier}`
        });
        return {
            status: (response && response.data && response.data.status) ? response.data.status : false,
            errors: (response && response.data && response.data.errors) ? response.data.errors : {},
            content: (response && response.data && response.data.result) ? response.data.result : ""
        }
    }
    catch (err) {
        return {
            status: false,
            errors: {},
            content: ""
        }
    }
}

export const getFaqlistAction = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/get-faq-list`,
            'data': data
        });
        return {
            status: (response && response.data && response.data.status) ? response.data.status : false,
            errors: (response && response.data && response.data.errors) ? response.data.errors : {},
            message: (response && response.data && response.data.message) ? response.data.message : "",
            result: (response && response.data && response.data.result) ? response.data.result : {},
        }
    }
    catch (err) {
        return {
            status: false,
            errors: {},
            message: "Failed",
            authToken: null,
        }
    }
}

export const getSieUrls = async (data) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `${apiUrl}/get-site-url`,
            'data': data
        });
        return {
            status: (response && response.data && response.data.status) ? response.data.status : false,
            message: (response && response.data && response.data.message) ? response.data.message : "",
            result: (response && response.data && response.data.result) ? response.data.result : {},
        }
    }
    catch (err) {
        return {
            status: false,
            errors: {},
            message: "Failed",
            authToken: null,
        }
    }
}

